const { z } = require('zod');

const brandSchema = z.enum(['today', 'nbcnews']);

/** @typedef {z.infer<typeof brandSchema>} Brand */

/**
 * @typedef {{
 *   oneTimeCode: string;
 *   bedrockSession: string;
 *   email: string;
 *   brand: Brand;
 * }} DeleteProfileRequestBody
 */

module.exports = {
  brandSchema,
};
